import type { ArtistSectionKey } from '../getArtistSections/getArtistSections';

/**
 * Builds the DOM id / scroll anchor for a projects section. Single source of
 * truth shared by ArtistsProjects (which renders the id on each `<section>`)
 * and the section components that scroll to themselves via `url.hash`, so the
 * anchor never drifts from the element id when `dataCy` changes.
 *
 * @param dataCyPrefix the projects prefix, i.e. `${dataCy}-projects`
 */
export const getSectionId = (
	dataCyPrefix: string,
	key: ArtistSectionKey
): string => `${dataCyPrefix}-section-${key}`;
